export default __webpack_public_path__ + "static/about_passion-cee5aec3abad356888557ac0607e3f33.jpg";